export default __webpack_public_path__ + "8899d22f58816903e4b624fac38dc577.png";